module.exports = __webpack_public_path__ + "static/media/Eclectic+Gallery+Wall+DIY+Tutorial_0015.ed52c848.jpeg";